import { render, staticRenderFns } from "./product_management_home.vue?vue&type=template&id=c665f586&scoped=true&"
import script from "./product_management_home.vue?vue&type=script&lang=js&"
export * from "./product_management_home.vue?vue&type=script&lang=js&"
import style0 from "./product_management_home.vue?vue&type=style&index=0&id=c665f586&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c665f586",
  null
  
)

export default component.exports